import React, { useContext, useState } from 'react';
import { useTeams } from '../hooks/team';
import TeamCalendar from '../components/TeamCalendar';
import { useCalendar } from '../hooks/calendar';
import { UserContext } from '../context/user-context';
import { RequireLoginModal } from '../components/RequireLoginModal';
import { Modal } from '../components/Modal';

export default function TeamCalendars() {
  const [teams] = useTeams();
  const { getTeamCalendarUrl } = useCalendar();
  const { isUserLoggedIn, login } = useContext(UserContext);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showCalendarModal, setShowCalendarModal] = useState(false);

  const onAddToCalendar = async (abbrv) => {
    if (isUserLoggedIn()) {
      setShowCalendarModal(getTeamCalendarUrl(abbrv));
    } else {
      setShowLoginModal(true);
    }
  };

  if (!teams) return null;

  return (
    <>
      {!isUserLoggedIn() && (
        <p className="text-color-primary-white mb-4">
          För att prenumerera på en kalender behöver du logga in med ditt
          Fotbollskonto. Saknar du ett Fotbollskonto?{' '}
          <a className="text-color-primary-yellow" href="/auth/login">
            Registrera dig gratis här!
          </a>
        </p>
      )}
      <div className="row">
        {teams.map((team) => (
          <TeamCalendar
            key={team.abbrv}
            team={team}
            onAddToCalendar={onAddToCalendar}
          />
        ))}
      </div>
      {showLoginModal && (
        <RequireLoginModal
          closeModal={() => setShowLoginModal(false)}
          login={login}
          heading="KALENDER"
          message="För att lägga till matcher i din kalender behöver du logga in på ditt
          Fotbollskonto."
        />
      )}
      {showCalendarModal && (
        <Modal
          closeModal={() => setShowCalendarModal(false)}
          heading="Starta prenumeration"
          content={
            <div className="text-center">
              <p className="text-regular mb-3">
                Klicka på knappen nedan för att starta prenumerationen.
                <br />
                Om knappen inte fungerar kan du behöva kopiera länken manuellt
                och lägga in i din kalender, se instruktioner längst ner på
                sidan.
              </p>

              <a
                type="button"
                href={showCalendarModal}
                className="button button--primary-yellow button--large mb-3"
              >
                Prenumerera
              </a>

              <p>Länk: {showCalendarModal}</p>
            </div>
          }
        />
      )}
    </>
  );
}
